import React from 'react';

/**
 * How much of the set-up is behind the user, as a bar and a completed/total
 * count. Not-applicable steps are already excluded from both numbers by
 * SetupWizardService::progress().
 */
export default function SetupProgressBar({ progress, labelStyle = 'ratio' }) {
    const percent = progress.total ? Math.round((progress.completed / progress.total) * 100) : 0;

    return (
        <div className="tw-flex tw-items-center tw-gap-x-2">
            <div
                role="progressbar"
                aria-label={$t('Set-up progress')}
                aria-valuenow={percent}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuetext={$t('{{completed}} of {{total}} steps complete', { completed: progress.completed, total: progress.total })}
                className="tw-flex-auto tw-h-1.5 tw-rounded-full tw-bg-charcoal-15 tw-overflow-hidden"
            >
                <div className="tw-h-full tw-bg-green" style={{ width: `${percent}%` }} />
            </div>
            {labelStyle === 'ratio' && (
                <span className="tw-text-xs tw-font-medium tw-text-charcoal">
                    {progress.completed}/{progress.total}
                </span>
            )}
        </div>
    );
}
